<template>
  <div class="admin-equipment-container">
    <ds-page-header :title="$t('adminEquipment.page.title')" :subtitle="$t('adminEquipment.page.subtitle')">
      <template #extra>
        <el-button type="primary" size="small" icon="el-icon-refresh" @click="handleSearch">{{ $t('common.refresh') }}</el-button>
      </template>
    </ds-page-header>
    <el-row :gutter="16">
      <el-col :span="4">
        <div class="ds-panel ds-panel--padded">
          <community-machine-type-tree ref="machineTypeTree" @selectMachineType="handleSelectMachineType" />
        </div>
      </el-col>
      <el-col :span="20">
        <ds-search-panel>
          <el-row :gutter="16">
            <el-col :span="6"><el-input v-model.trim="searchForm.machineName" :placeholder="$t('adminEquipment.search.machineName')" clearable /></el-col>
            <el-col :span="6"><el-input v-model.trim="searchForm.machineCode" :placeholder="$t('adminEquipment.search.machineCode')" clearable /></el-col>
            <el-col :span="6">
              <el-select v-model="searchForm.state" :placeholder="$t('adminEquipment.search.state')" style="width:100%" clearable>
                <el-option v-for="item in useStatus" :key="item.statusCd" :label="item.name" :value="item.statusCd" />
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select v-model="searchForm.importanceLevel" :placeholder="$t('adminEquipment.search.importanceLevel')" style="width:100%" clearable>
                <el-option v-for="item in importanceLevels" :key="item.statusCd" :label="item.name" :value="item.statusCd" />
              </el-select>
            </el-col>
          </el-row>
          <template #actions>
            <el-button type="primary" size="small" icon="el-icon-search" @click="handleSearch">{{ $t('common.search') }}</el-button>
            <el-button size="small" icon="el-icon-refresh" @click="handleReset">{{ $t('common.reset') }}</el-button>
          </template>
        </ds-search-panel>
        <div class="ds-panel">
          <ds-toolbar :total="pagination.total" :density="density" :show-column-setting="false" @update:density="density = $event" @refresh="getList">
            <template #left><span class="ds-panel__title">{{ $t('adminEquipment.search.title') }}</span></template>
          </ds-toolbar>
          <ds-data-table :data="tableData" :loading="loading" :error="hasError" :error-message="errorMessage" :density="density" border :empty-description="$t('adminEquipment.page.empty')" @retry="getList">
            <el-table-column prop="machineName" :label="$t('adminEquipment.table.machineName')" align="center" min-width="130" />
            <el-table-column prop="machineCode" :label="$t('adminEquipment.table.machineCode')" align="center" width="130"><template slot-scope="scope"><span class="ds-num">{{ scope.row.machineCode || '-' }}</span></template></el-table-column>
            <el-table-column prop="brand" :label="$t('adminEquipment.table.brand')" align="center" width="110"><template slot-scope="scope">{{ scope.row.brand || '-' }}</template></el-table-column>
            <el-table-column prop="model" :label="$t('adminEquipment.table.model')" align="center" width="110"><template slot-scope="scope">{{ scope.row.model || '-' }}</template></el-table-column>
            <el-table-column prop="locationDetail" :label="$t('adminEquipment.table.locationDetail')" align="center" min-width="150"><template slot-scope="scope">{{ scope.row.locationDetail || '-' }}</template></el-table-column>
            <el-table-column prop="firstEnableTime" :label="$t('adminEquipment.table.firstEnableTime')" align="center" width="170"><template slot-scope="scope"><span class="ds-num">{{ scope.row.firstEnableTime || '-' }}</span></template></el-table-column>
            <el-table-column prop="warrantyDeadline" :label="$t('adminEquipment.table.warrantyDeadline')" align="center" width="170"><template slot-scope="scope"><span class="ds-num">{{ scope.row.warrantyDeadline || '-' }}</span></template></el-table-column>
            <el-table-column prop="usefulLife" :label="$t('adminEquipment.table.usefulLife')" align="center" width="100"><template slot-scope="scope"><span class="ds-num">{{ scope.row.usefulLife || '-' }}</span></template></el-table-column>
            <el-table-column prop="levelName" :label="$t('adminEquipment.table.levelName')" align="center" width="110"><template slot-scope="scope"><ds-status-tag size="sm" type="info" :label="scope.row.levelName || '-'" /></template></el-table-column>
            <el-table-column prop="stateName" :label="$t('adminEquipment.table.stateName')" align="center" width="110"><template slot-scope="scope"><ds-status-tag size="sm" type="muted" :label="scope.row.stateName || '-'" /></template></el-table-column>
            <el-table-column prop="purchasePrice" :label="$t('adminEquipment.table.purchasePrice')" align="center" width="110"><template slot-scope="scope"><span class="ds-num">{{ scope.row.purchasePrice || '-' }}</span></template></el-table-column>
            <el-table-column prop="netWorth" :label="$t('adminEquipment.table.netWorth')" align="center" width="110"><template slot-scope="scope"><span class="ds-num">{{ scope.row.netWorth || '-' }}</span></template></el-table-column>
          </ds-data-table>
          <ds-pagination-bar :page="pagination.current" :size="pagination.size" :total="pagination.total" :summary="$t('adminEquipment.statusTip')" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { listAdminEquipmentAccount } from '@/api/resource/adminEquipmentApi'
import CommunityMachineTypeTree from '@/components/resource/CommunityMachineTypeTree'
import { getDict } from '@/api/community/communityApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsSearchPanel from '@/components/ds/ds-search-panel.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'
import DsPaginationBar from '@/components/ds/ds-pagination-bar.vue'
import DsStatusTag from '@/components/ds/ds-status-tag.vue'
export default {
  name: 'AdminEquipmentList',
  components: { CommunityMachineTypeTree, DsPageHeader, DsSearchPanel, DsToolbar, DsDataTable, DsPaginationBar, DsStatusTag },
  data() {
    return {
      loading: false, hasError: false, errorMessage: '', density: 'default',
      searchForm: { machineName: '', machineCode: '', communityId: '', state: '', importanceLevel: '', typeId: '' },
      tableData: [], useStatus: [], importanceLevels: [],
      pagination: { current: 1, size: 10, total: 0 }
    }
  },
  created() { this.getDictData(); this.getList() },
  methods: {
    async getDictData() {
      try {
        const stateData = await getDict('equipment_account', 'state'); this.useStatus = stateData
        const levelData = await getDict('equipment_account', 'importance_level'); this.importanceLevels = levelData
      } catch (error) { console.error('Failed to load dictionary data:', error) }
    },
    async getList() {
      try {
        this.loading = true; this.hasError = false
        const params = { ...this.searchForm, page: this.pagination.current, row: this.pagination.size }
        const { data, total } = await listAdminEquipmentAccount(params)
        this.tableData = data; this.pagination.total = total
      } catch (error) { this.hasError = true; this.errorMessage = this.$t('common.loadError'); this.$message.error(this.$t('adminEquipment.fetchError')) } finally { this.loading = false }
    },
    handleSelectMachineType(data) { this.searchForm.typeId = data.typeId; this.searchForm.communityId = data.communityId; this.handleSearch() },
    handleSearch() { this.pagination.current = 1; this.getList() },
    handleReset() { this.searchForm.machineName = ''; this.searchForm.machineCode = ''; this.searchForm.state = ''; this.searchForm.importanceLevel = ''; this.searchForm.typeId = ''; this.handleSearch() },
    handleSizeChange(val) { this.pagination.size = val; this.getList() },
    handleCurrentChange(val) { this.pagination.current = val; this.getList() }
  }
}
</script>
<style lang="scss" scoped>
.admin-equipment-container { padding: var(--ds-spacing-lg); background-color: var(--ds-gray-100); min-height: calc(100vh - 60px); }
.ds-panel { background: #fff; border: 1px solid var(--ds-gray-300); border-radius: var(--ds-radius-md); box-shadow: var(--ds-shadow-sm); overflow: hidden; margin-bottom: var(--ds-spacing-lg);
  &--padded { padding: var(--ds-spacing-md); }
  &__title { font-size: var(--ds-font-size-lg); font-weight: 600; color: var(--ds-gray-800); } }
</style>
